import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginHeader from "./components/LoginHeader";
import LoginForm from "./components/LoginForm";
import { getAuth } from "../../api/clientService";

const AUTH_REMEMBER_KEY = "auth.remember";

const Login: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // If already logged in, route to Stream Management
    const auth = getAuth();
    const remember = localStorage.getItem(AUTH_REMEMBER_KEY) === "true";

    if (auth?.accessToken) {
      if (remember || isTokenValid(auth.tokenExpires)) {
        navigate("/stream-management");
      } else {
        // token expired & not remembered — clear?
        // (optional) leave it; server will 401 and we’ll redirect on failure.
      }
    }
  }, [navigate]);
  //To be deleted - comment added to trigger build

  // Handles both seconds and ms just in case (we’ll firm up once backend confirms)
  function isTokenValid(tokenExpires?: number | null): boolean {
    if (!tokenExpires) return true; // if backend didn’t send, assume valid until 401
    const now = Date.now();
    const asMs = tokenExpires > 10_000_000_000 ? tokenExpires : tokenExpires * 1000;
    return now < asMs;
  }
  //comment for new build ( to be removed later ) 

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="absolute inset-0 -z-10">
        {/* If you had a separate bg component */}
      </div>

      <div className="w-full max-w-md relative">
        <div className="bg-card border border-border rounded-xl shadow-modal p-8 backdrop-blur-sm">
          <LoginHeader />
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default Login;
